var SeatingChartUtil = (function(window, $){
    var COLOR_BANK = {
        empty: '#ACACAC',
        low: '#B0DD76',
        medium: '#4C9550',
        high: '#13676A'
    };

    function getColor(percentage) {
        if (percentage === 0) {
            return COLOR_BANK.empty;
        } else if (percentage < 25) {
            return COLOR_BANK.low;
        } else if (percentage < 50) {
            return COLOR_BANK.medium;
        }

        return COLOR_BANK.high;
    }

    function colorElement($element, percent) {
        var color = getColor(percent);

        $element.css('fill', color).css('fill-opacity', '1').css('stroke', color);

        if (percent === 0){
            $element.attr('class', 'section unavailable');
        }
    }

    function colorChart() {
        $('#chart .section').not('text').each(function(_, targetElement) {
            var $targetElement = $(targetElement);
            var sectionId = $targetElement.attr('section_id');
            var currentSection = window.FG.Event.sectionInfo[sectionId];

            if (currentSection) {
                var availableSeats = parseInt(currentSection.availableSeats, 10);
                var totalSeats = parseInt(currentSection.totalSeats, 10);
                var percent = (availableSeats / totalSeats) * 100;

                colorElement($targetElement, percent);
            }
        });
    }

    function sanitizeXML(xml) {
        var xmlDoc = $.parseXML(xml);

        // find <g> elements with class="section"
        $(xmlDoc).find('g[class="section"]').each(function(_, currentElement){
            var $currentElement = $(currentElement);
            var sectionId = $currentElement.attr('section_id');

            // ensure all descendants inherit class and section_id from original <g>
            $currentElement.find('*').each(function(_, kid){
                var $kid = $(kid);
                $kid.attr('class', 'section');
                $kid.attr('section_id', sectionId);
            });
        });

        return xmlDoc.documentElement;
    }

    return {
        colorSections: colorChart,
        sanitizeXML: sanitizeXML
    };
}(window, window.jQuery));

